<template>
  <div 
    class="sd-modal-container position-fixed w-100 h-100 z-3 d-flex align-items-center justify-content-center top-0 start-0" 
    @click="$emit('showmodalevent', false)" 
    v-if="props.showmodal"
  >
    <div class="row sd-tab-row p-4 bg-white position-relative" @click.prevent.stop>
      <div class="sd-modal-image-container flex-column mb-3">
        <div class="sd-image-wrapper rounded-pill p-3">
          <img :src="props.showmodal.image" width="100" alt="Image">
        </div>
        <h2 class="text-white fw-bold">{{ props.showmodal.name }}</h2>
      </div>
      
      <!-- Beschrijving Tab -->
      <div 
        class="tab" 
        @click="toggleTab('description')" 
        :class="{ active: activeTab === 'description' }"
      >
        <h3 class="mb-0">Beschrijving</h3>
        <transition name="slide" class="mt-3">
           <p 
            class="sd-modal-content" 
            v-if="activeTab === 'description'" 
            v-html="props.showmodal?.description"
          ></p>
        </transition>
      </div>
      
      <!-- Allergie informatie Tab -->
      <div 
        class="tab" 
        @click="toggleTab('allergy')" 
        :class="{ active: activeTab === 'allergy' }"
      >
        <h3 class="mb-0">Allergie informatie</h3>
        <transition name="slide" class="mt-3">
          <div 
            v-if="activeTab === 'allergy'" 
            class="sd-modal-content mb-2 mt-2" 
            v-html="props.showmodal?.acf?.allergie_informatie"
          ></div>
        </transition>
      </div>
      
      <!-- Ingrediënten Tab -->
      <div 
        class="tab" 
        @click="toggleTab('ingredients')" 
        :class="{ active: activeTab === 'ingredients' }"
      >
        <h3 class="mb-0">Ingrediënten</h3>
        <transition name="slide" class="mt-3">
           <div 
            v-if="activeTab === 'ingredients'" 
            class="sd-modal-content mb-2 mt-2" 
            v-html="props.showmodal?.acf?.ingredients"
          ></div>
        </transition>
      </div>
      
      <button class="sd-btn" @click="$emit('showmodalevent', false)">Sluiten</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';

const props = defineProps(['showmodal', 'boxdata']);
const activeTab = ref('description');

const toggleTab = (tab) => {
  // Toggle the selected tab; collapse if same tab is clicked again.
  activeTab.value = activeTab.value === tab ? null : tab;
};
</script>

<style scoped>
/* 1) Container background stays the same */
.sd-modal-container {
  background: #4141418c;
}

/* 2) A cleaner animation for the modal itself: 
      use transform: translateY instead of top. */
@keyframes slideIn {
  0% {
    transform: translateY(100%); /* Off-screen bottom */
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 3) Apply the keyframe animation to the modal content row */
.sd-modal-container .sd-tab-row {
  max-width: 450px;
  border-radius: 14px;
  animation: slideIn 0.6s ease forwards;
}

/* Basic typography */
h2 {
  letter-spacing: -1px;
  margin-top: -15px;
}
h3 {
  font-size: 24px;
  letter-spacing: -1px;
  font-weight: 800;
  display: flex;
  align-items: center;
}

/* Tabs */
.sd-tab-row > .tab {
  border-bottom: 1px solid #dddddd;
  padding: 10px 0;
  cursor: pointer;
}

/* Content inside the modal */
.sd-modal-content {
  max-height: 200px; /* Or whatever vertical limit you want */
  overflow: auto;
}

/* Image container styling */
.sd-modal-image-container {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  min-height: 200px;
  background-color: #395AD4;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sd-image-wrapper {
  background-color: #5677F0;
}
.sd-modal-image-container > img {
  position: relative;
  object-fit: contain;
}

/* Button styles */
.sd-btn {
  display: inline-flex;
  width: auto;
  margin: auto;
  margin-top: 20px;
  border-radius: 100px;
  padding: 13px 35px;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.5px;
}
.sd-btn i {
  font-weight: 700;
  margin-left: 7px;
  font-size: 13px;
  margin-bottom: -2px;
}

/* 4) Updated transition classes for a slide effect of tab content:
      Instead of max-height changes, we animate transform + opacity. */
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: block;
}
.slide-enter-from, .slide-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
.slide-enter-to, .slide-leave-from {
  transform: translateY(0);
  opacity: 1;
}

</style>
